import React from 'react'
import cx from 'classnames'

import { renderFields } from '@/utls'

import store from '../../state/store.js'

class ApplyForm extends React.Component {
  constructor () {
    super()
    this.state = {
      formSubmit: false
    }
    this.form = React.createRef()
  }
  handleSubmit (e) {
    e.preventDefault()
    const {
      email,
      firstName,
      lastName,
      title,
      company,
      phone,
      category,
      sticker,
      website,
      instagram,
      about,
      location,
      plan
    } = this.form.current.elements
    fetch(`/.netlify/functions/application`, {
      method: 'POST',
      body: JSON.stringify({
        email: email.value,
        firstName: firstName.value,
        lastName: lastName.value,
        title: title.value,
        company: company.value,
        phone: phone.value,
        category: category.value,
        sticker: sticker.value,
        website: website.value,
        instagram: instagram.value,
        about: about.value,
        location: location.value,
        plan: plan.value
      })
    })
      .then(res => res.json())
      .then(res => {
        if (res.error) {
          console.log('error')
        } else {
          this.setState({
            formSubmit: true
          })
        }
      })
  }
  render () {
    return (
      <React.Fragment>
        <div className={cx('container--l mxa ac p15 apply__form-thanks', {
          'is-visible': this.state.formSubmit
        })}>
          <h3 className='h1'>We'll be in Touch!</h3>
        </div>
        <form ref={this.form} onSubmit={(e) => this.handleSubmit(e)} className={cx('container--l mxa p15 apply__form', {
          'is-hidden': this.state.formSubmit
        })}>
          <div className='apply__block f jcb ais fw'>
            <div>
              <h5 className='caps medium'>Brand Application</h5>
              <h2 className='mt0 pt0'>Tell us about yourself</h2>
            </div>
            <div className='apply__fields f jcb aic fw x'>
              {store.state.app['about'].map(field => (
                renderFields(field)
              ))}
            </div>
          </div>
          <div className='apply__block x f jcb ais fw'>
            <div>
              <h2 className='mt0 pt0'>Tell us about your brand</h2>
            </div>
            <div className='apply__fields f jcb aic fw x'>
              {store.state.app['brand'].map(field => (
                renderFields(field)
              ))}
            </div>
          </div>
          <div className='apply__block f jcb ais fw'>
            <div>
              <h2 className='mt0 pt0'>Select your location</h2>
            </div>
            <div className='apply__fields'>
              {store.state.app['location'].map(field => (
                renderFields(field)
              ))}
            </div>
          </div>
          <div className='apply__block f jcb ais fw'>
            <div>
              <h2 className='mt0 pt0'>Select your package</h2>
            </div>
            <div className='apply__fields'>
              {store.state.app['package'].map(field => (
                renderFields(field)
              ))}
            </div>
          </div>
          <div className='mt1 pt1 ac'>
            <button type='submit' className='button inline-block block button__outline button__peach'>
              <span>Submit</span>
            </button>
          </div>
        </form>
      </React.Fragment>
    )
  }
}

export default ApplyForm